<!-- Tutto quello che é in javascript:void(0) va cambiato con gli url del comune se non vi é servizio di recupero header e footer -->
<div class="it-header-wrapper">
  <div class="it-header-slim-wrapper background-secondary">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="it-header-slim-wrapper-content">
            <a class="d-none d-lg-block navbar-brand me-0" target="_blank" href="javascript:void(0)" data-focus-mouse="false">Regione <span *ngIf="configurazione">{{ configurazione.regione }}</span></a>
            <div class="nav-mobile">
              <nav aria-label="Navigazione secondaria">
                <a class="d-block d-lg-none navbar-brand collapsed" data-bs-toggle="collapse" href="#service-menu" role="button"
                   aria-expanded="false" aria-controls="service-menu" data-focus-mouse="false">
<!--                  <span>Links</span>-->
<!--                  <svg class="icon">-->
<!--                    <use href="./content/svg/sprites.svg#it-expand"></use>-->
<!--                  </svg>-->
                  <a class="d-block navbar-brand me-0" target="_blank" href="javascript:void(0)" data-focus-mouse="false">Regione <span *ngIf="configurazione">{{ configurazione.regione }}</span></a>
                </a>
                <div id="service-menu" class="link-list-wrapper collapse" style="">
                  <ul class="link-list" *ngIf="!homePageHeaderFooter">
                    <li class="list-item d-block d-md-none">
                      <a target="_blank" href="javascript:void(0)" class="fw-normal">Regione <span *ngIf="configurazione">{{ configurazione.regione }}</span></a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div class="it-header-slim-right-zone" role="navigation">
              <!--<div [ngSwitch]="account != null" class="it-access-top-wrapper"
                   style="margin-right: 0.4rem; position: relative">
                <a *ngSwitchCase="true" class="btn btn-primary btn-sm secondary-button-darker"
                   (click)="mostraAttivitaNotifiche()" title="Notifiche">
                  <span class="notify-badge"
                        [ngClass]="{'font-11 padding-3-8': this.notificheservice.numNotifiche >= 10, 'font-14 padding-3-10': this.notificheservice.numNotifiche <= 9}"
                        style="z-index: 10; position:absolute;"
                        *ngIf="notificheservice.numNotifiche !== 0 && notificheservice.numNotifiche">{{ this.notificheservice.numNotifiche }}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-bell-fill" style="z-index: -1" viewBox="0 0 16 16">
                    <path
                      d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
                  </svg>
                </a>
              </div> -->
              <!--<div class="dropdown" *ngIf="languages && languages.length > 1">
                <a class="btn btn-dropdown dropdown-toggle" role="button" id="dropdownMenuLink"
                   data-bs-toggle="dropdown" aria-haspopup="true">
                  <img [src]="'content/images/flag/' + lingua + '.png'" width="26px" height="26px" class="mx-1"
                       alt="Lingua" />
                  <svg class="icon-expand icon icon-sm icon-primary icon-white">
                    <use href="./content/svg/sprites.svg#it-expand"></use>
                  </svg>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                  <div class="link-list-wrapper">
                    <ul class="link-list">
                      <li *ngFor="let language of languages" value="{{language}}">
                        <a class="dropdown-item list-item" style="color: #0d5aa7"
                           (click)="changeLanguage(language); collapseNavbar()">
                          <img [src]="'content/images/flag/' + language + '.png'" width="26px" height="26px"
                               class="mx-1" alt="Lingua" />
                          {{ language | findLanguageFromKey }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
              <a *ngIf="account == null" class="btn btn-primary btn-icon btn-full" (click)="login()">
                <span class="rounded-icon" aria-hidden="true">
        <svg class="icon icon-primary">
            <use href="./content/svg/sprites.svg#it-user"></use>
        </svg>
    </span>
                <span class="d-none d-lg-block">Accedi all'area personale</span>
              </a>
              <div *ngIf="account">
                <span class="text-decoration-none btn btn-icon btn-full text-white"
                      style="padding: 14px 16px !important;" data-bs-toggle="dropdown">
                    <span class="circle" style="display: flex; margin: auto">
                      <svg class="icon icon-lg icon-primary icon-color">
                        <use href="./content/svg/sprites.svg#it-user"></use>
                      </svg>
                    </span>
                  <span class="" *ngIf="windowSize > 960">&nbsp;&nbsp;{{ account.firstName }} {{ account.lastName }}</span>
                </span>
                <div class="dropdown-menu rounded-3 pb-0 w-auto" id="dropdownProfilo"
                     aria-labelledby="dropdownMenuButton"
                     style="z-index: 2147483647 !important;">
                  <div class="link-list-wrapper">
                    <ul class="link-list">
                      <ng-container *ngFor="let item of this.nav">
                        <ng-container *ngIf="item.nmServizio === 'Impostazioni'">
                          <li class="my-2" *ngFor="let funzione of item.funzioniServizio; index as i">
                            <a class="list-item left-icon"
                               (click)="routing(navServ.navRouting.get(funzione.nmComponent))">
                              <svg class="icon icon-xl icon-color left w-fixed h-auto show" viewBox="0 0 1024 1024">
                                <use [attr.xlink:href]="funzione.dbFunzione"></use>
                              </svg>
                              <span class="text-color">&nbsp;{{ funzione.nmTitolo }}</span>
                            </a>
                          </li>
                        </ng-container>
                      </ng-container>
                      <li class="my-2">
                        <a class="list-item left-icon" (click)="goToAreaPersonale()">
                          <svg class="icon icon-xl icon-color left w-fixed h-auto show" viewBox="0 0 1024 1024">
                            <use href="./content/svg/sprites.svg#it-calendar"></use>
                          </svg>
                          <span class="text-color">Area Personale</span>
                        </a>
                        <hr class="my-0 mx-3" />
                      </li>
                      <li>
                        <div [ngSwitch]="account != null" class="it-access-top-wrapper">
                          <a *ngSwitchCase="true" class="btn btn-primary btn-sm secondary-button-darker"
                             (click)="logout()"
                             jhiTranslate="navbar.esci">Esci</a>

                          <a *ngSwitchCase="false" class="btn btn-primary btn-sm px-3 secondary-button-darker"
                             (click)="login()"
                             routerLink="home"
                             routerLinkActive="active" jhiTranslate="navbar.accedi">Accedi</a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="it-nav-wrapper">
    <div class="it-header-center-wrapper background-primary">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="it-header-center-content-wrapper">
              <div class="it-brand-wrapper">
                <a (click)="goToHome()">
                  <div *ngIf="account" class="it-brand-text d-flex align-items-center">
                    <a (click)="goToHome()">
                      <img [src]="homePageHeaderFooter ? homePageHeaderFooter.Footer.Municipality.Logo: getImage()" alt="" class="icon" [width]="windowSize > 1000 ? 82 : 64"
                           [height]="windowSize > 1000 ? 82 : 64" />
                      <div class="it-brand-text">
                        <div class="it-brand-title" *ngIf="!homePageHeaderFooter">Comune di
                          <span
                            *ngIf="configurazione && configurazione.nome">{{ configurazione.nome }}</span></div>
                        <div class="it-brand-title" style="margin-left: 0.3em"
                             *ngIf="homePageHeaderFooter">{{ homePageHeaderFooter.Footer.Contacts.City }}
                        </div>
                        <!-- Mostra tagline dinamica se esiste homePageHeaderFooter -->
                        <div class="it-brand-tagline d-none d-md-block" *ngIf="homePageHeaderFooter">
                          Il portale del {{ homePageHeaderFooter.Footer.Contacts.City }}
                        </div>

                        <!-- Altrimenti mostra tagline fissa -->
                        <div class="it-brand-tagline d-none d-md-block" *ngIf="!homePageHeaderFooter">
                          Il portale istituzionale del comune
                        </div>
                      </div>
                    </a>
                  </div>
                  <div *ngIf="!account" class="it-brand-text d-flex align-items-center">
                    <img [src]="getImage()" class="icon" alt="" width="82" height="82" />
                    <div *ngIf="!homePageHeaderFooter">
                      <div class="it-brand-title" *ngIf="configurazione && configurazione.nome">Comune
                        di {{ configurazione.nome }}
                      </div>
                      <div class="it-brand-tagline d-none d-md-block">
                        Il portale istituzionale del comune
                      </div>
                    </div>
                    <div *ngIf="homePageHeaderFooter">
                      <div class="it-brand-title">{{ homePageHeaderFooter.Footer.Contacts.City }}
                      </div>
                      <div class="it-brand-tagline d-none d-md-block">
                        Il portale del {{ homePageHeaderFooter.Footer.Contacts.City }}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="it-right-zone">
                <div class="it-socials d-none d-lg-flex">
                  <span *ngIf="configurazione.flFacebook || configurazione.flInstagram || configurazione.flTwitter">Seguici su:</span>
                  <ul *ngIf="!homePageHeaderFooter">
                    <li *ngIf="configurazione.flFacebook">
                      <a href="{{configurazione.linkFacebook}}" target="_blank">
                        <svg class="icon">
                          <use href="./content/svg/sprites.svg#it-facebook"></use>
                        </svg>
                        <span class="visually-hidden">Facebook</span>
                      </a>
                    </li>
                    <li *ngIf="configurazione.flInstagram">
                      <a href="{{configurazione.linkInstagram}}" target="_blank">
                        <svg class="icon">
                          <use href="./content/svg/sprites.svg#it-instagram"></use>
                        </svg>
                        <span class="visually-hidden">Instagram</span>
                      </a>
                    </li>
                    <li *ngIf="configurazione.flTwitter">
                      <a href="{{configurazione.linkTwitter}}" target="_blank">
                        <svg class="icon">
                          <use href="./content/svg/sprites.svg#it-whatsapp"></use>
                        </svg>
                        <span class="visually-hidden">Whatsapp</span>
                      </a>
                    </li>
                  </ul>
                  <ul *ngIf="homePageHeaderFooter">
                    <li *ngFor="let social of homePageHeaderFooter.Header.FollowOn">
                      <a [attr.href]="social.Href" target="_blank">
                        <svg class="icon">
                          <use xmlns:xlink="http://www.w3.org/1999/xlink"
                               [attr.href]="'./content/svg/sprites.svg#' + social.Item"></use>
                        </svg>
                        <span class="visually-hidden">{{social.Social}}</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="it-search-wrapper">
                  <span class="d-none d-md-block text-white">Cerca </span>
                  <a class="search-link rounded-icon" aria-label="Cerca nel sito" data-bs-toggle="modal"
                     data-bs-target="#searchModal">
                    <svg class="icon">
                      <use href="./content/svg/sprites.svg#it-search"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="it-header-navbar-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="navbar navbar-expand-lg has-megamenu">
              <button class="custom-navbar-toggler" type="button" aria-controls="nav4" aria-expanded="false"
                      aria-label="Mostra/Nascondi la navigazione" data-bs-target="#nav4"
                      data-bs-toggle="navbarcollapsible" data-focus-mouse="false">
                <svg class="icon">
                  <use href="./content/svg/sprites.svg#it-burger"></use>
                </svg>
              </button>
              <div class="navbar-collapsable" id="nav4" style="display: none" aria-hidden="true">
                <div class="overlay fade" style="display: none;"></div>
                <div class="close-div">
                  <button class="btn close-menu" type="button" data-focus-mouse="false">
                    <span class="visually-hidden">Nascondi la navigazione</span>
                    <svg class="icon">
                      <use href="./content/svg/sprites.svg#it-close-big"></use>
                    </svg>
                  </button>
                </div>
                <div class="menu-wrapper">
                  <a (click)="goToHome()" aria-label="Vai alla homepage" class="logo-hamburger">
                    <div width="48" height="48" aria-hidden="true">
                      <img [src]="homePageHeaderFooter ? homePageHeaderFooter.Footer.Municipality.Logo: getImage()" alt="" class="icon" [width]="windowSize > 1000 ? 82 : 64"
                           [height]="windowSize > 1000 ? 82 : 64" />
                    </div>
                    <div class="it-brand-text">
                      <div class="it-brand-title">Comune di <span>{{ configurazione ? configurazione.nome : '' }}</span></div>
                    </div>
                  </a>
                  <nav aria-label="Principale" *ngIf="!homePageHeaderFooter">
                    <ul class="navbar-nav" id="menu-main-menu" data-element="main-navigation">
                      <li class="nav-item">
                        <a class="nav-link" [href]="configurazione.baseUrl + '/amministrazione/'"
                           data-element="management">
                          <span class="fw-normal">Amministrazione</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" [href]="configurazione.baseUrl + '/novita/'" data-element="news">
                          <span class="fw-normal">Novità</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" [href]="configurazione.linkServizi" data-element="all-services">
                          <span class="fw-normal">Servizi</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" [href]="configurazione.baseUrl + '/vivere-il-comune/'" data-element="live"
                           data-focus-mouse="false">
                          <span class="fw-normal">Vivere il Comune</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                  <nav *ngIf="homePageHeaderFooter">
                    <ul class="navbar-nav" id="menu-main-menu-api" data-element="main-navigation">
                      <li class="nav-item" *ngFor="let leftHeaderItem of homePageHeaderFooter.Header.LeftHeader">
                        <a class="nav-link"
                           [attr.href]="leftHeaderItem.External ? leftHeaderItem.Href :  homePageHeaderFooter.BaseURLSito + '/' + leftHeaderItem.Href"
                           [attr.data-element]="leftHeaderItem.DataElement">
                          <span class="fw-normal">{{ leftHeaderItem.Label }}<svg class="icon icon-white icon-sm align-middle" *ngIf="leftHeaderItem.External"><use href="./content/svg/sprites.svg#it-external-link"></use></svg></span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                  <nav aria-label="Secondaria" *ngIf="!homePageHeaderFooter">
                    <ul class="navbar-nav navbar-secondary">
                      <li class="nav-item">
                        <a class="nav-link" [href]="configurazione.baseUrl + '/argomenti/'" data-element="all-topics">
                          <span class="fw-bold">Tutti gli argomenti</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                  <nav aria-label="Secondaria" *ngIf="homePageHeaderFooter">
                    <ul class="navbar-nav navbar-secondary">
                      <li class="nav-item" *ngFor="let rightHeaderItem of homePageHeaderFooter.Header.RightHeader">
                        <a class="nav-link" [attr.href]="rightHeaderItem.External ? rightHeaderItem.Href :  homePageHeaderFooter.BaseURLSito + '/' + rightHeaderItem.Href" [attr.data-element]="rightHeaderItem.DataElement">{{rightHeaderItem.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="rightHeaderItem.External"><use href="./content/svg/sprites.svg#it-external-link"></use></svg></a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" [attr.href]="homePageHeaderFooter.BaseURLSito + '/argomenti'" data-element="all-topics">
                          <span class="fw-bold">Tutti gli argomenti</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                  <div class="it-socials">
                    <span *ngIf="configurazione.flFacebook || configurazione.flInstagram || configurazione.flTwitter">Seguici su:</span>
                    <ul *ngIf="!homePageHeaderFooter">
                      <li *ngIf="configurazione.flFacebook">
                        <svg class="icon">
                          <use xmlns:xlink="http://www.w3.org/1999/xlink"
                               href="./content/svg/sprites.svg#it-facebook"></use>
                        </svg>
                        <span class="visually-hidden">Facebook</span>
                      </li>
                      <li *ngIf="configurazione.flInstagram">
                        <svg class="icon">
                          <use xmlns:xlink="http://www.w3.org/1999/xlink"
                               href="./content/svg/sprites.svg#it-instagram"></use>
                        </svg>
                        <span class="visually-hidden">Instagram</span>
                      </li>
                      <li *ngIf="configurazione">
                        <svg class="icon">
                          <use xmlns:xlink="http://www.w3.org/1999/xlink"
                               href="./content/svg/sprites.svg#it-whatsapp"></use>
                        </svg>
                        <span class="visually-hidden">Whatsapp</span>
                      </li>
                    </ul><!-- /header-social-wrapper -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<input type="hidden" data-bs-toggle="modal" data-bs-target="#searchModal" #_MD_SEARCH>
<!-- Modale ricerca per argomento -->
<div class="modal fade search-modal" tabindex="-1" role="dialog" id="searchModal" aria-labelledby="exampleModalTitle">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content perfect-scrollbar">
      <div class="modal-body">
        <div class="container">
          <div class="row variable-gutters">
            <div class="col">
              <div class="modal-title">
                <button type="button" data-bs-toggle="modal" data-bs-target="#searchModal"
                        aria-label="Chiudi e torna alla pagina precedente" class="search-link d-none">
                  <svg class="icon icon-md">
                    <use href="./content/svg/sprites.svg#it-arrow-left"></use>
                  </svg>
                </button>
                <h2>Cerca</h2>
                <button type="button" data-bs-toggle="modal" data-bs-target="#searchModal"
                        aria-label="Chiudi e torna alla pagina precedente" class="search-link d-none d-md-block"
                        data-focus-mouse="false">
                  <svg class="icon icon-md">
                    <use href="./content/svg/sprites.svg#it-close-big"></use>
                  </svg>
                </button>
              </div>
              <div class="form-group autocomplete-wrapper">
                <div class="container">
                  <div class="col-12">
                    <form [formGroup]="formSearch" (submit)="searchClick()">
                      <ng-autocomplete placeholder="Cerca servizi..." (inputChanged)='searchInputChange($event)'
                                       [data]="resultNew" [customFilter]="customFilter" [itemTemplate]="itemTemplate"
                                       [notFoundTemplate]="notFoundTemplate" [searchKeyword]="keyword"
                                       formControlName="searchText"
                      ></ng-autocomplete>
                    </form>
                  </div>
                  <div class="row">
                    <div class="col-12 mt-3">
                      <button type="button" (click)="searchClick()"
                              class="btn btn-primary btn-sm float-end"
                              style="margin-left: 1rem;"> Cerca
                      </button>
                      <button type="button" data-bs-toggle="modal"
                              data-bs-target="#searchModal" aria-label="Chiudi e torna alla pagina precedente"
                              class="btn btn-outline-primary btn-sm float-end" data-focus-mouse="false">Chiudi
                      </button>
                    </div>
                  </div>
                  <div class="row justify-content-between mt-3" *ngIf="selectedResult && selectedResult.length > 0">
                    <div class="col-lg-4 text-start">
                      {{ countResults }} Risultati
                    </div>
                    <div class="col-lg-4 text-center">
                      <button type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                              aria-expanded="true" class="btn btn-dropdown dropdown-toggle" style="font-size: medium"
                              data-focus-mouse="false"> Ordinamento: <span
                        *ngIf="!normalSearch">{{ filterAct === '+' ? 'Titolo crescente' : filterAct === '-' ? 'Titolo decrescente' : '' }}</span><span
                        *ngIf="normalSearch">{{ filterAct === '+' ? 'Macroarea crescente' : filterAct === '-' ? 'Macroarea decrescente' : '' }}</span>
                        <svg class="icon-expand icon icon-sm icon-primary">
                          <use href="./content/svg/sprites.svg#it-expand"></use>
                        </svg>
                      </button>
                      <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                        <div class="link-list-wrapper">
                          <ul class="link-list">
                            <li *ngIf="!normalSearch">
                              <button type="button" class="btn" data-focus-mouse="false"
                                      (click)="sortSelectedResult('+')">Titolo crescente
                              </button>
                            </li>
                            <li *ngIf="!normalSearch">
                              <button type="button" class="btn" data-focus-mouse="false"
                                      (click)="sortSelectedResult('-')">Titolo decrescente
                              </button>
                            </li>
                            <li *ngIf="normalSearch">
                              <button type="button" class="btn" data-focus-mouse="false"
                                      (click)="sortSelectedResult('+')">Macroarea crescente
                              </button>
                            </li>
                            <li *ngIf="normalSearch">
                              <button type="button" class="btn" data-focus-mouse="false"
                                      (click)="sortSelectedResult('-')">Macroarea decrescente
                              </button>
                            </li>

                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 text-end c-pointer"
                         (click)="this.formSearch.reset(); this.selectedResult = []">Rimuovi tutti i filtri
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let area of selectedResult">
            <div class="row justify-content-center" *ngFor="let serv of area.funzioniServizio">
              <div class="col-lg-11">
                <div class="cmp-card-latest-messages mb-3 mb-30">
                  <div class="card shadow-sm px-4 pt-4 pb-4 rounded border mb-2 my-0"><span
                    class="visually-hidden">Categoria:</span>
                    <div class="card-header border-0 p-0"><a
                      class="text-decoration-none title-xsmall-bold mb-2 category text-uppercase">{{ area.nmServizio }} </a>
                    </div>
                    <div class="card-body p-0 my-2"><h3 class="green-title-big t-primary mb-8"><a
                      data-element="service-link" class="text-decoration-none service-link text-primary"
                      title="Vai alla pagina: {{serv.nmTitolo}}" (click)="
                        serv.codice
                          ? routingTributi(navService.navRouting.get(serv.nmComponent), serv)
                          : routingComp(serv.nmComponent)"> {{ serv.nmTitolo }} </a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="(selectedResult && selectedResult.length == 0) && initSearch">
            <div class="container">
              <div class="col-12">
                <p>Nessun risultato trovato</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #itemTemplate let-item>
  <div class="d-flex justify-content-between align-items-center"
       (click)="handleServizioSingolo(item.nmTitolo, item.macroArea)"><a>
    <span><a class="fw-normal" [innerHTML]="item.nmTitolo"></a></span>
  </a>
    <div class="d-flex align-items-center">
      <span class="me-2 fs-small" [innerHTML]="item.macroArea"></span>
      <svg class="icon icon-xs icon-primary me-4">
        <use [attr.href]="item.svg"></use>
      </svg>
    </div>
  </div>
</ng-template>

<ng-template #notFoundTemplate let-notFound>
  <div [innerHTML]="'Nessun risultato trovato'"></div>
</ng-template>
